import React from 'react';

import { ExpiryStatus } from 'client-code/vod-browse';

import { CcbSwitch } from '../../../core/utils/ccb';
import { CcbSwitchName } from '../../../core/utils/ccb/enums';
import { Mousetrap, ProgressBar } from '../../common';
import { VodPreview } from '../../common/VodPreview/VodPreview';
import { VodScreenType } from '../../common/VodPreview/VodPreviewProps';

import './VodListView.scss';

export const LEFT_QUOTE = String.fromCharCode(8216);
export const RIGHT_QUOTE = String.fromCharCode(8217);
export const SPACED_DASH = ' - ';

interface VodListViewProps {
    items: any;
    position: number;
    ghostMode?: boolean;
}

const VodListView: React.FC<VodListViewProps> = ({ items, position, ghostMode = false }) => {
    const isVodPreviewEnabled = CcbSwitch.getInstance().isEnabledAndOverriden(
        CcbSwitchName.ENABLE_VOD_PREVIEW_REMOVE_IN_KST_14762,
    );

    const getSuffixTitle = (item: any): string => {
        if (item?.vodItemType?.includes('Movie') || item?.vodItemType?.includes('movie')) {
            return item.movieYear ? ` (${item.movieYear})` : '';
        }
        if (item?.vodItemType?.includes('Episode') || item?.vodItemType?.includes('episode')) {
            const season = item?.seasonNumber ? `S${item?.seasonNumber}` : '';
            const episode = item?.episodeNumber ? `E${item?.episodeNumber}` : '';
            const episodeTitle = item?.episodeTitle
                ? ` ${LEFT_QUOTE}${item?.episodeTitle}${RIGHT_QUOTE}`
                : '';
            return episodeTitle ? `${SPACED_DASH}${season} ${episode} ${episodeTitle}` : '';
        }
        return '';
    };

    const getExpiryStatus = (expiryStatus?: ExpiryStatus): string => {
        if (!expiryStatus) return '';

        const expiryClassMap: Record<ExpiryStatus, string> = {
            [ExpiryStatus.ExpiresIn24Hours]: 'entitlement-expiry-24-hours',
            [ExpiryStatus.ExpiresIn72Hours]: 'entitlement-expiry-72-hours',
        };

        return expiryClassMap[expiryStatus] || '';
    };

    return (
        <React.Fragment>
            {items?.map((item, index) => (
                <Mousetrap
                    value={`${index}_list-view`}
                    key={`${item.id}-${index}`}
                    className={`list-item${index === position ? ` focused${ghostMode ? ' ghostHighlight' : ''}` : ''}`}
                >
                    <div>
                        <span className="title">
                            {item.title}
                            {getSuffixTitle(item)}
                        </span>
                    </div>
                    <span className="list-item-icons">
                        {item && item?.percentWatched > 0 && (
                            <div className="list-item-details">
                                <ProgressBar percentage={item.percentWatched} />
                            </div>
                        )}
                        <span className={`icon-expiry ${getExpiryStatus(item.expiryStatus)}`} />
                    </span>
                </Mousetrap>
            ))}
            <div className="vod-my-rentals-preview-container">
                {isVodPreviewEnabled && (
                    <VodPreview
                        screenType={VodScreenType.VOD_MY_RENTAL_LIST_SCREEN}
                        item={items && items.length > 0 ? items[position] : []}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default VodListView;
